import { render, staticRenderFns } from "./ReckonNumberRecord.vue?vue&type=template&id=d98760a8&"
import script from "./ReckonNumberRecord.vue?vue&type=script&lang=js&"
export * from "./ReckonNumberRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReckonNumberRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports